import React, { type ReactNode } from 'react';

interface ScreenReaderAnnouncementProps {
  ariaHidden?: boolean;
  polite?: boolean;
  message?: ReactNode;
}

const ScreenReaderAnnouncement = ({
  ariaHidden = false,
  message,
  polite = false,
}: ScreenReaderAnnouncementProps) => (
  <div
    aria-hidden={ariaHidden || undefined}
    aria-live={polite ? 'polite' : 'assertive'}
    className="sr-only"
    data-testid="sr"
  >
    {message}
  </div>
);

export default ScreenReaderAnnouncement;
